export default "__VITE_ASSET__5Si3$NJp__"